import { CSSProperties } from 'react'

import { MenuSection } from '@/types'

export const TOP_BAR_HEIGHT_DESKTOP = 80
export const TOP_BAR_HEIGHT_MOBILE = 68

export const CHECKOUT_PAGE_PATH = 'en/order/checkout'
export const PAYMENT_PAGE_PATH = 'en/order/payment/payment-router'
export const REDEMPTION_PAGE_PATH = 'en/order/payment/redemption'

export const SOCIAL_LINK_TEXT: string[] = ['Facebook', 'Instagram', 'YouTube']

export const MENU_SECTIONS: MenuSection[] = [
  {
    title: 'Join Us',
    links: [
      { label: 'Affiliate Partners', url: '/en/partnerships' },
      {
        label: 'Experience Operators',
        url: 'https://www.thebigredgroup.com.au/our-network/experience-operators/',
        target: '_blank',
      },
      { label: 'Careers', url: 'https://www.thebigredgroup.com.au/team/jobs-overview/', target: '_blank' },
      { label: "Let's Collaborate", url: '/en/work-with-us' },
    ],
  },
  {
    title: 'Our Company',
    links: [
      { label: 'About Us', url: '/en/about-us' },
      { label: 'FAQs', url: '/en/faqs' },
      { label: 'Blogs', url: '/en/blog' },
      { label: 'Privacy Policy', url: '/en/privacy-policy' },
      { label: 'Terms and Conditions', url: '/en/terms-and-conditions' },
      { label: 'Security', url: '/en/security' },
    ],
  },
  {
    title: 'Get in Touch',
    links: [
      { label: 'Contact Us', url: '/en/faqs' },
      { label: 'Press Room', url: '/en/media-and-pr-enquiries' },
      { label: 'Visit The Experience Centre', url: '/en/experience-centre' },
    ],
  },
]

export const TOASTER_STYLE: CSSProperties = {
  maxWidth: '400px',
  width: '100%',
  padding: '0',
  animation: 'none',
}

export const TOASTER_CLASS_NAME = 'react-hot-toast-container'

export { Z_INDEX } from '@big-red-group/storefront-common-ui'
export const BASE_MOBILE_TOP_BAR_HEIGHT = 68
export const HAPPY_HOUR_BANNER_HEIGHT = 30